export default "__VITE_ASSET__Cyf9F5MW__"